import textsEnGb from './translationTexts-engb.json';

export const translations = {
  [textsEnGb.language]: textsEnGb,
};

export type translationsType = typeof textsEnGb.translations;
